<template>
  <section id="how-to-order" class="bg-blueberry-lighter/15 px-4 py-10 md:py-16">
    <div class="max-w-3xl mx-auto mb-8 md:mb-16 text-center">
      <h2 class="text-3xl md:text-4xl font-bold text-navy mb-6">
        {{ t('howToOrder.title') }}
      </h2>
      <div class="w-24 h-1 bg-leaf mx-auto mb-6 rounded-full"></div>
      <p class="text-lg text-muted-foreground">{{ t('howToOrder.subtitle') }}</p>
    </div>
    <ol
      class="list-decimal list-inside max-w-xl mx-auto space-y-4 text-foreground/80"
    >
      <li>
        <i18n-t keypath="howToOrder.step1" tag="span">
          <template #button>
            <strong>„Zamów Teraz"</strong>
          </template>
        </i18n-t>
      </li>
      <li>
        <i18n-t keypath="howToOrder.step2" tag="span">
          <template #delivery>
            <strong>Dostawa do domu</strong>
          </template>
          <template #pickup>
            <strong>Odbiór osobisty</strong>
          </template>
        </i18n-t>
      </li>
      <li>{{ t('howToOrder.step3') }}</li>
      <li>{{ t('howToOrder.step4') }}</li>
    </ol>
    <div class="text-center mt-8">
      <OrderGateLink
        class="bg-blueberry-dark text-white px-8 py-3 rounded-md font-semibold hover:bg-blueberry-dark/80 transition"
      >
        {{ t('howToOrder.orderNow') }}
      </OrderGateLink>
    </div>
  </section>
</template>

<script setup lang="ts">
import OrderGateLink from "@/components/OrderGateLink.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
